import { apiClient } from '../../../../lib/api-client';
import { DocumentResult } from '../types/DocumentResult';

export async function apiGetDocument(documentID: number): Promise<DocumentResult> {
	try {
		return await apiClient.get("document/document",
			{
				params: { documentID: documentID }
			});
	} catch (error: any) {
		return {
			isSuccess: false,
			errorMessage: error
		} as DocumentResult;
	}
};
